import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { StepItemIndicatorsComponent } from './step-item-indicators.component';
import { IndicatorsModule } from 'components/indicators/indicators.module';

@NgModule({
  imports: [CommonModule, NgbTooltipModule, IndicatorsModule],
  declarations: [StepItemIndicatorsComponent],
  exports: [StepItemIndicatorsComponent],
})
export class StepItemIndicatorsModule {}
